import { render, staticRenderFns } from "./profile_edit.vue?vue&type=template&id=650780f6"
import script from "./profile_edit.vue?vue&type=script&lang=js"
export * from "./profile_edit.vue?vue&type=script&lang=js"
import style0 from "./profile_edit.vue?vue&type=style&index=0&id=650780f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports